import { createStore, applyMiddleware, compose } from "redux"
import { composeWithDevTools } from "redux-devtools-extension"
import { persistStore, persistReducer } from "redux-persist"
import thunkMiddleware from "redux-thunk"
import rootReducer from '../reducers'
import storage from 'redux-persist/lib/storage'

const persistConfig = {
	key: 'root',
    storage: storage,
    whitelist: ['auth'],
    blacklist: ['pagination']
};

const middlewares = [ thunkMiddleware ]

const persistedReducer = persistReducer(persistConfig, rootReducer)

export default () => {
	let store = createStore(persistedReducer, composeWithDevTools(
		applyMiddleware(...middlewares),
    ))
    
    let persistor = persistStore(store)
    
	return { store, persistor }
}


// WEBPACK FOOTER //
// ./src/configureStore/configureStore.ts